import { decorate, observable, computed } from 'mobx';
import { ParentStore } from '@mq/voltron-parent';

class CardProductJitFundingStore extends ParentStore {
  constructor(args: Object = {}) {
    super(args);
    this.load(args);
  }
  // values
  paymentcard_funding_source: object = {};
  programgateway_funding_source: object = {};
  program_funding_source: object = {};

  // computed
  get fundingType() {
    if (this.paymentcard_funding_source?.enabled) {
      return 'Pre-Funded';
    }

    if (this.program_funding_source?.enabled) {
      return 'Managed JIT';
    }

    if (this.programgateway_funding_source?.enabled) {
      return 'Gateway JIT';
    }
  }
}

decorate(CardProductJitFundingStore, {
  // values
  paymentcard_funding_source: observable,
  programgateway_funding_source: observable,
  program_funding_source: observable,

  // computed
  fundingType: computed,
});

export default CardProductJitFundingStore;
